document.addEventListener('DOMContentLoaded', () => {
  const headMenus = document.querySelectorAll('.header_menu .header_menu_item');
  const mainMenus = document.querySelectorAll('.header__menu-item');
  const headerSection = document.querySelector('.shopify-section-header-sticky');
  const mainMobileMenus = document.querySelectorAll(".menu-drawer__menu-item");
  const menusBack = document.querySelectorAll(".header_menu .header_menu_item_back")

  // hover 主菜单时，显示对应子菜单
  mainMenus.forEach((item, index) => {
    item.addEventListener('mouseenter', () => {
      mainMenus.forEach(m => m.classList.remove('active'));
      item.classList.add("active")
      headMenus.forEach(m => m.classList.add('hidden'));
      const target = headMenus[index];
      if (target) {
        // 设置 top 值为 header 的高度
        if (window.scrollY > 0) {
          target.closest(".header_menu").style.top = "89px"; // 绝对定位用
        } else {
          target.closest(".header_menu").style.top = "129px"; // 绝对定位用
        }

        target.classList.remove('hidden');
      }
    });
  });

    // 监听整个页面的滚动
  window.addEventListener('scroll', function(event) {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > 0 && window.innerWidth >= 1024) {
        document.querySelector(".header_menu").style.top = "89px";
      } else {
         document.querySelector(".header_menu").style.top = "129px";
      }
  });

  mainMobileMenus.forEach((item, index) => {
    item.addEventListener('click', () => {
      document.querySelector(".header_menu").style.display = "block"
      mainMenus.forEach(m => m.classList.remove('active'));
      item.classList.add("active")
      headMenus.forEach(m => m.classList.add('hidden'));
      const target = headMenus[index];
      if (target) {
        // 设置 top 值为 header 的高度
        if (window.scrollY > 0) {
          target.closest(".header_menu").style.top = "68px"; // 绝对定位用
        } else {
          target.closest(".header_menu").style.top = "108px"; // 绝对定位用
        }

        target.classList.remove('hidden');
        target.closest(".shopify-block").style.display = "block"
      }
    });
  })

  // 当鼠标离开整个 header 区域或二级菜单区域时隐藏
  document.addEventListener('mousemove', (e) => {
    const isInHeader = headerSection.contains(e.target);
    const isInSubMenu = Array.from(headMenus).some(menu => menu.contains(e.target));

    if (!isInHeader && !isInSubMenu) {
      headMenus.forEach(m => m.classList.add('hidden'));
      mainMenus.forEach(m => m.classList.remove('active'));
    }
  });

  headMenus.forEach(item => {
    const links = item.querySelectorAll('.header_menu_link');
    const secondMenus = item.querySelectorAll('.second_menu');
    if (secondMenus && secondMenus.length > 0) {
      item.querySelector(".second_menu").classList.remove("hidden")
      links.forEach((link, index) => {
        link.addEventListener('mouseenter', () => {
          links.forEach(m => m.classList.remove('active'));
          link.classList.add("active")
          // 先全部隐藏
          secondMenus.forEach(m => m.classList.add('hidden'));

          // 再显示对应的
          const target = secondMenus[index];
          if (target) target.classList.remove('hidden');
        });
      });
    }
  })

  menusBack.forEach((item, index) => {
    item.addEventListener('click', () => {
      document.querySelector(".header_menu").style.display = "none"
      const target = headMenus[index];
      if (target) {
        target.classList.add('hidden');
        target.closest(".shopify-block").style.display = "none"
      }
    });
  })
});